const ScreenWidth = {
  mobile: "320px",
  preTablet: "767px",
  tablet: "768px",
  preDesktop: "1439px",
  desktop: "1440px",
};

export default ScreenWidth;
